import { render } from "./Label.vue?vue&type=template&id=0b1f3fce"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=0b1f3fce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__